export const supportReportReducer = (
	state = {
		supportListData:[],
        supportCount:0
	},
	action
) => {
	switch (action.type) {
		case "SUPPORT_REQUEST_LIST":
		case "SUPPORT_REQUEST_SUCCESS":
			return {
				...state,
				supportListData: action.payload.list,
				supportCount: action.payload.count,
				
			};
	
		default:
			return state;
	}
};
